import { useMemo } from 'react';
import { formatDateToBR } from 'utils/date';

export function useAlgoliaDateFilters(dateFilter: string | null) {
  const numericFilters = useMemo(() => {
    if (!dateFilter) {
      return [];
    }
    let startDateStr: string;
    let endDateStr: string;

    if (dateFilter.includes(',')) {
      [startDateStr, endDateStr] = dateFilter.split(',');
    } else {
      startDateStr = dateFilter;
      endDateStr = dateFilter;
    }

    const startDate = new Date(`${startDateStr}T00:00:00`);
    const endDate = new Date(`${endDateStr}T00:00:00`);
    endDate.setHours(23, 59, 59, 999);

    const startTimestamp = startDate.getTime() / 1000;
    const endTimestamp = endDate.getTime() / 1000;

    return [`end_date<=${endTimestamp}`, `start_date>=${startTimestamp}`];
  }, [dateFilter]);

  const formattedDate = useMemo(() => {
    if (!dateFilter) {
      return '';
    }

    let startDateStr: string;
    let endDateStr: string;

    if (dateFilter.includes(',')) {
      [startDateStr, endDateStr] = dateFilter.split(',');
    } else {
      startDateStr = dateFilter;
      endDateStr = dateFilter;
    }

    const formattedStart = formatDateToBR(startDateStr);
    const formattedEnd = formatDateToBR(endDateStr);

    return formattedStart === formattedEnd
      ? formattedStart
      : `${formattedStart} à ${formattedEnd}`;
  }, [dateFilter]);

  return { numericFilters, formattedDate };
}
